// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Definición de la colección LoginWeb baked at build time.
// NO EDITAR: se regenera en cada build.

export const COLL_DEF = {
  "name": "LoginWeb",
  "tableName": "LoginWeb",
  "tablePrefix": "gen",
  "idFieldName": "ROWID",
  "fields": [
    {
      "name": "MAP_LOGO_WEB",
      "type": "TL",
      "title": "KPI"
    },
    {
      "name": "MAP_LBL_BIENVENIDO",
      "type": "TL",
      "title": "Bienvenido"
    },
    {
      "name": "MAP_LBL_INSTRUC",
      "type": "TL",
      "title": "Introduce tus credenciales para acceder"
    },
    {
      "name": "MAP_LOGIN",
      "type": "T"
    },
    {
      "name": "MAP_PASSWORD",
      "type": "X"
    },
    {
      "name": "MAP_LBL_TEST_CRED",
      "type": "TL",
      "title": "Pruebas: admin / ChangeMe!2026"
    },
    {
      "name": "MAP_LBL_FOOTER_WEB",
      "type": "TL",
      "title": "Dashboard KPI v1.0.0 | Acceso seguro"
    },
    {
      "name": "ROWID",
      "type": "T",
      "size": 32
    }
  ],
  "linkedTo": {
    "kind": "rest",
    "collection": "LoginWeb"
  }
} as const;
